import React, { useState } from 'react';
import { CheckIcon } from '@phosphor-icons/react';
import { IoMdInformationCircleOutline } from 'react-icons/io';

export default function SelectionCard({ item, isSelected, onToggle, language, primaryColor }) {
  const [showInfo, setShowInfo] = useState(false);
  const name = item[`name_${language}`] || item.name;

  const image = item.logo || './images/default-card.png'; // Fallback if no image

  const imagePath = process.env.REACT_APP_AWS_URL + image;
  const description = item[`description_${language}`] || item.description || '';

  return (
    <div
      onClick={onToggle}
      className="relative border border-gray-300 rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow">
      {/* Image */}
      <div className={`relative}`}>
        <img src={imagePath} alt={name} className="w-full h-full object-cover" />

        {/* Selection Overlay - Top Right */}
        <div className="absolute top-3 right-3">
          {isSelected ? (
            <div
              style={{ backgroundColor: primaryColor || '#2B4B8C' }}
              className="w-12 h-12 rounded-full flex items-center justify-center">
              <CheckIcon className="text-white text-xl" weight="bold" />
            </div>
          ) : (
            <div className="w-12 h-12 bg-white rounded-full border-2 border-gray-300" />
          )}
        </div>

        {/* Dimmed overlay when selected */}
        {isSelected && <div className="absolute inset-0 bg-white bg-opacity-40" />}
      </div>

      {/* Label */}
      <div className="p-4 bg-white text-center flex justify-between items-center">
        <p className="text-sm font-normal text-gray-800">{name}</p>
        <button
          type="button"
          className="bg-gray-400 rounded-full p-2"
          onClick={(e) => {
            e.stopPropagation();
            setShowInfo(true);
          }}
          aria-label="Show info">
          <IoMdInformationCircleOutline className="text-white" />
        </button>
      </div>
      {showInfo && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          onClick={(e) => {
            e.stopPropagation();
            setShowInfo(false);
          }}>
          {/* Overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-60" />
          {/* Card */}
          <div
            className="relative mx-4 bg-white rounded-2xl shadow-xl max-w-2xl w-full p-8"
            onClick={(e) => e.stopPropagation()}>
            {/* Close */}
            <button
              type="button"
              aria-label="Close"
              className="absolute top-4 right-4 text-2xl text-gray-700 hover:text-gray-900"
              onClick={() => setShowInfo(false)}>
              ×
            </button>
            {/* Title */}
            <h2 className="text-center text-2xl font-bold mb-4" style={{ color: primaryColor }}>
              {name}
            </h2>
            {/* Description */}
            <p
              className="text-center text-gray-600 leading-7"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
